import { logger } from '@modules/logger';
import { nanoid } from 'nanoid';
import { Analytics, AnalyticsUser, PageEvent, TrackEvent, IdentifyEvent } from './types';

interface ZarazSetOptions {
  scope: 'page' | 'session' | 'persist';
}

interface ZarazServices {
  track: (eventName: string, properties: Record<string, unknown>) => void;
  set: (key: string, value: string, options?: ZarazSetOptions) => void;
}
class ZarazAnalytics implements Analytics {
  constructor(private getZaraz: () => ZarazServices) {}

  async initialize(): Promise<void> {
    return;
  }

  identify(e: Partial<IdentifyEvent>): void {
    if (e?.user_id) this.getZaraz().set('user_id', e.user_id);
    if (e?.traits) {
      Object.entries(e.traits).forEach(([key, value]) => {
        this.getZaraz().set(key, String(value));
      });
    }
  }
  group(): void {
    logger.debug('Zaraz group No-op');
  }
  user(): AnalyticsUser | undefined {
    // logger.debug('Zaraz user No-op');
    return undefined;
  }
  reset(): void {
    // logger.debug('Zaraz user No-op');
  }
  track(e: Partial<TrackEvent>): void {
    if (e.name) {
      e.type = 'track';
      e.platform = 'dash';
      e.message_id = nanoid();
      this.getZaraz().track(e.name, e);
    }
  }
  page(e: Partial<PageEvent>): void {
    e.name = 'page_view';
    e.type = 'page';
    e.platform = 'dash';
    e.message_id = nanoid();
    this.getZaraz().track('page_view', e);
  }
  set(key: string, value: string, options?: ZarazSetOptions) {
    logger.debug('Zaraz setting', { [key]: value, options });
    this.getZaraz().set(key, value, options);
  }
}
declare const zaraz: ZarazServices | undefined;

function getZarazInstance() {
  return typeof zaraz !== 'undefined'
    ? zaraz
    : {
        track: () => logger.warn('Track is not available, zaraz is not configured'),
        set: () => logger.warn('Set is not available, zaraz is not configured'),
      };
}

export const zarazAnalytics = new ZarazAnalytics(getZarazInstance) as Analytics;
